/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react/jsx-filename-extension */
import React, { useState, useEffect, useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import styled from 'styled-components';
import { i18n } from '../../translate/i18n';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import './calendar.css';
import moment from 'moment';
import {
  Container,
  Drawer,
  Button,
  Chip,
  Typography,
  Dialog,
} from '@mui/material';
import { Launch } from '@mui/icons-material';
import FilterList from '@mui/icons-material/FilterList';
import * as actions from '../../store/actions';
import CustomEvent from './CustomEvent';
import 'moment/locale/pt-br';
import 'moment/locale/es';
import EventModal from './EventModal/EventModal';
import Spinner from '../Spinner/index';
import ModalFilter from './ModalFilter/index';
import { formatLanguageFromLocalStorage } from '../../utils/formatLanguageFromLocalStorage';
import ExportModalCalendar from '../ExportModalCalendar';

//moment.locale('pt-br');
const localizer = momentLocalizer(moment);

const CalendarStyled = styled(Calendar)`
  height: 700px !important;
`;

const messages = {
  allDay: 'Dia todo',
  previous: '<',
  next: '>',
  today: 'Hoje',
  month: 'Mês',
  week: 'Semana',
  day: 'Dia',
  agenda: 'Agenda',
  date: 'Data',
  time: 'Tempo',
  event: 'Evento',
  showMore: total => `+ Eventos (${total})`,
};

const MyCalendar = (props) => {
  const dispatch = useDispatch();

  const [view, setView] = useState('month');
  const [displayedDateRage, setDisplayedDateRage] = useState({});
  const [displayedDateRageExportExcel, setDisplayedDateRageExportExcel] = useState({});
  const [firstLoad, setFirstLoad] = useState(true);

  const calendarEvents = useSelector(state => state.calendars.calendarEvents);
  const calendarDate = useSelector(state => state.calendars.calendarDate);
  const loading = useSelector(state => state.calendars.loading);
  const selectedSites = useSelector(state => state.sites.selectedSitesPlaces);
  const [isFilterOpen, setIsFilterOpen] = useState(false);
  const [exportLoading, setExportLoading] = useState(false);
  const [exportModalOpen, setExportModalOpen] = useState(false);

  // Modal Filter
  const filteredUsers = useSelector(state => state.calendars.filteredUsers);
  const filteredUsersMaintenances = useSelector(state => state.calendars.filteredUsersMaintenances);
  const filteredEquipmentModels = useSelector(state => state.calendars.filteredEquipmentModels);
  const filteredEquipmentGroups = useSelector(state => state.calendars.filteredEquipmentGroups);
  const filteredServiceTypes = useSelector(state => state.calendars.filteredServiceTypes);
  const filteredFrequencies = useSelector(state => state.calendars.filteredFrequencies);
  const filteredPlaces = useSelector(state => state.calendars.filteredPlaces);
  const filteredModules = useSelector(state => state.calendars.filteredModules);
  const filteredAreas = useSelector(state => state.calendars.filteredAreas);
  const filteredStatus = useSelector(state => state.calendars.filteredStatus);
  const filteredStatusMaintenances = useSelector(state => state.calendars.filteredStatusMaintenances);
  const filteredCompanies = useSelector(state => state.calendars.filteredCompanies);

  const localStorageLang = localStorage.getItem("i18nextLng");
  const emailLanguage = formatLanguageFromLocalStorage(localStorageLang);

  // Export Excel
  const fetchCalendarsExport = useCallback(() => dispatch(actions.fetchCalendarsExport(displayedDateRageExportExcel.start, displayedDateRageExportExcel.end, selectedSites, filteredUsers, filteredUsersMaintenances, filteredEquipmentModels, filteredEquipmentGroups, filteredServiceTypes, filteredFrequencies, filteredPlaces, filteredModules, filteredStatus, filteredStatusMaintenances, filteredAreas, filteredCompanies, emailLanguage)), [displayedDateRageExportExcel, selectedSites, filteredUsers, filteredUsersMaintenances, filteredEquipmentModels, filteredEquipmentGroups, filteredServiceTypes, filteredFrequencies, filteredPlaces, filteredModules, filteredStatus, filteredStatusMaintenances, filteredAreas, filteredCompanies, emailLanguage]);

  // fetch from BE
  const fetchCalendars = useCallback((after, before, sites, users, usersMaintenances, equipmentModels, equipmentGroups, filteredModules, areas, companies) => dispatch(actions.fetchCalendars(after, before, sites, users, usersMaintenances, equipmentModels, equipmentGroups, filteredModules, areas, companies, filteredPlaces, filteredServiceTypes, filteredFrequencies, filteredStatus, filteredStatusMaintenances)));

                                                                                                                                              
  const computeDisplayedDateRange = () => {
    let start = moment(calendarDate).startOf(view);
    let end = moment(calendarDate).endOf(view);
    if (view === 'month') {
      start = start.subtract(7, 'days');
      end = end.add(7, 'days');
    }
    setDisplayedDateRage({ start: start.toString(), end: end.toString() });
  };

  const computeDisplayedDateRangeExportExcel = () => {
    let start = moment(calendarDate).startOf(view);
    let end = moment(calendarDate).endOf(view);

    setDisplayedDateRageExportExcel({ start: start.toString(), end: end.toString() });
  };

  useEffect(() => {
    if (!firstLoad) {
      fetchCalendars(displayedDateRage.start, displayedDateRage.end, selectedSites, filteredUsers, filteredUsersMaintenances, filteredEquipmentModels, filteredEquipmentGroups, filteredModules, filteredAreas, filteredCompanies, filteredPlaces, filteredServiceTypes, filteredFrequencies,filteredStatus, filteredStatusMaintenances);
    }
  }, [displayedDateRage, selectedSites, filteredUsers, filteredUsersMaintenances, filteredEquipmentModels, filteredEquipmentGroups, filteredModules, filteredAreas, filteredPlaces, filteredServiceTypes, filteredFrequencies, filteredCompanies,filteredStatus, filteredStatusMaintenances]);

	useEffect(() => {
		dispatch(actions.setOpenDrawer(true))
    setFirstLoad(false)
	}, [])

  useEffect(() => {
    computeDisplayedDateRange();
    computeDisplayedDateRangeExportExcel();
  }, [calendarDate]);

  const onSelectEvent = (e) => {
    dispatch(actions.modalCalendarsOpen({ modalType: e.type, date: e.start, stage: e.stage, title: e.title }));
  };

  const onNavigate = (date) => {
    dispatch(actions.setCalendarsDate(date));
  };

  const deleteFilteredSite = (site) => {
    dispatch(actions.deleteFilteredSite(site));
  };

  const deleteFilteredUser = (user) => {
    dispatch(actions.filterCalendarUsersRemove(user));
  };

  const deleteFilteredUserMaintenances = (user) => {
    dispatch(actions.filterCalendarUsersMaintenancesRemove(user));
  };

  const deleteFilteredEquipmentModels = (equipmentModel) => {
    dispatch(actions.filterCalendarEquipmentModelsRemove(equipmentModel));
  };

  const deleteFilteredEquipmentGroups = (equipmentGroup) => {
    dispatch(actions.filterCalendarEquipmentGroupsRemove(equipmentGroup));
  };

  const deleteFilteredPlaces = (places) => {
    dispatch(actions.filterCalendarPlacesRemove(places));
  };

  const deleteFilteredModules = (module) => {
    dispatch(actions.filterCalendarModulesRemove(module));
  };

  const deleteFilteredServiceTypes = (serviceType) => {
    dispatch(actions.filterCalendarServiceTypesRemove(serviceType))
  }

  const deleteFilteredFrequency = (frequency) => {
    dispatch(actions.filterCalendarFrequenciesRemove(frequency))
  }

  const deleteFilteredArea = (area) => {
    dispatch(actions.filterCalendarAreasRemove(area));
  };
  const deleteFilteredCompany = (company) => {
    dispatch(actions.filterCalendarCompaniesRemove(company));
  };
  const deleteFilteredStatus = (status) => {
    dispatch(actions.filterCalendarStatusRemove(status));
  };
  const deleteFilteredStatusMaintenances = (status) => {
    dispatch(actions.filterCalendarStatusMaintenancesRemove(status));
  };

  const clearFilterButton = () => {
    if ((filteredUsers && filteredUsers.length > 0)
    || (filteredUsersMaintenances && filteredUsersMaintenances.length > 0)
    || (filteredEquipmentModels && filteredEquipmentModels.length > 0)
    || (filteredServiceTypes && filteredServiceTypes.length > 0)
    || (filteredEquipmentGroups && filteredEquipmentGroups.length > 0)
    || (filteredPlaces && filteredPlaces.length > 0)
    || (filteredFrequencies && filteredFrequencies.length > 0)
    || (filteredModules && filteredModules.length > 0)
    || (filteredCompanies && filteredCompanies.length > 0)
    || (filteredAreas && filteredAreas.length > 0)
    || (filteredStatus && filteredStatus.length > 0)
    || (filteredStatusMaintenances && filteredStatusMaintenances.length > 0)) return <Typography onClick={handleClickClearFilters} style={styles.clearFilter}>{i18n.t('typographyCalendar.clearFilterButton')}</Typography>;
  };

  const handleModulesLabels = (module) => {
    switch(module) {
      case 'actions': return i18n.t('calendarChipsToggles.actions');
      case 'maintenances': return i18n.t('calendarChipsToggles.maintenances');
      case 'services': return i18n.t('calendarChipsToggles.services_performed');
      case 'servicesReplicated': return i18n.t('calendarChipsToggles.services_to_be_performed');
      case 'future services': return i18n.t('calendarChipsToggles.future_services');
    }
  };

  const renderSiteChips = () => (selectedSites && selectedSites.map(site => (<Chip
    key={site._id}
    label={site.name}
    onDelete={() => deleteFilteredSite(site)}
    style={styles.filterChip} />)));
  const renderUsersChips = () => (filteredUsers && filteredUsers.map(user => (<Chip
    key={user.value}
    label={user.label}
    onDelete={() => deleteFilteredUser(user)}
    style={styles.filterChip} />)));
  const renderUsersMaintenancesChips = () => (filteredUsersMaintenances && filteredUsersMaintenances.map(user => (<Chip
    key={user.value}
    label={user.label}
    onDelete={() => deleteFilteredUserMaintenances(user)}
    style={styles.filterChip} />)));
  const renderServiceTypesChips = () => (filteredServiceTypes && filteredServiceTypes.map((serviceType) => (<Chip
    key={serviceType.value}
    label={serviceType.label}
    onDelete={() => deleteFilteredServiceTypes(serviceType)}
    style={styles.filterChip} />)))
  const renderFrequenciesChips = () => (filteredFrequencies && filteredFrequencies.map((frequency) => (<Chip
    key={frequency.value}
    label={frequency.label}
    onDelete={() => deleteFilteredFrequency(frequency)}
    style={styles.filterChip} />)))
  const renderEquipmentModelsChips = () => (filteredEquipmentModels && filteredEquipmentModels.map(equipmentModel => (<Chip
    key={equipmentModel.value}
    label={equipmentModel.label}
    onDelete={() => deleteFilteredEquipmentModels(equipmentModel)}
    style={styles.filterChip} />)));
  const renderEquipmentGroupsChips = () => (filteredEquipmentGroups && filteredEquipmentGroups.map(equipmentGroup => (<Chip
    key={equipmentGroup.value}
    label={equipmentGroup.label}
    onDelete={() => deleteFilteredEquipmentGroups(equipmentGroup)}
    style={styles.filterChip} />)));
  const renderPlacesChips = () => (filteredPlaces && filteredPlaces.map(place => (<Chip
    key={place.value}
    label={place.label}
    onDelete={() => deleteFilteredPlaces(place)}
    style={styles.filterChip} />)));
  const renderModulesChips = () => (filteredModules && filteredModules.map(module => (<Chip
    key={module}
    label={handleModulesLabels(module)}
    onDelete={() => deleteFilteredModules(module)}
    style={styles.filterChip} />)));
  const renderAreasChips = () => (filteredAreas && filteredAreas.map(area => (<Chip
    key={area.value}
    label={area.label}
    onDelete={() => deleteFilteredArea(area)}
    style={styles.filterChip} />)));
  const renderCompaniesChips = () => (filteredCompanies && filteredCompanies.map(company => (<Chip
    key={company.value}
    label={company.label}
    onDelete={() => deleteFilteredCompany(company)}
    style={styles.filterChip} />)));
  const renderStatusChips = () => (filteredStatus && filteredStatus.map(status => (<Chip
    key={status.value}
    label={status.label}
    onDelete={() => deleteFilteredStatus(status)}
    style={styles.filterChip} />)));
  const renderStatusMaintenancesChips = () => (filteredStatusMaintenances && filteredStatusMaintenances.map(status => (<Chip
    key={status.value}
    label={status.label}
    onDelete={() => deleteFilteredStatusMaintenances(status)}
    style={styles.filterChip} />)));
  const handleClickClearFilters = useCallback(() => dispatch(actions.filterCalendarClear()));

  const exportExcel = () => {
    setExportLoading(true);
    fetchCalendarsExport()
      .then(response => {
        if (response) {
          window.open(response.url, "_blank")
        }
        setExportLoading(false);
      })
      .catch(() => setExportLoading(false))
  }

  return <>
    <Drawer
      variant="temporary"
      anchor="right"
      onClose={() => setIsFilterOpen(false)}
      open={isFilterOpen}
    >
      <ModalFilter
        closeModal={() => setIsFilterOpen(false)}
      />
    </Drawer>
    <Dialog
      onClose={() => setExportModalOpen(false)}
      open={exportModalOpen}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
      }}
    >
      <ExportModalCalendar closeModal={() => setExportModalOpen(false)} />
    </Dialog>
    <Container maxWidth="lg" style={{ position: 'relative' }}>

      <div style={{ display: 'flex', justifyContent: 'space-between'}}>
        <Button
          variant="contained"
          onClick={() => setIsFilterOpen(true)}
          style={styles.buttonFilter}>
            {i18n.t('buttonCompCalendar.filter')}
            {' '}
            <FilterList style={styles.buttonFilterIcon} />
        </Button>

        <div>
          <Button
            variant='outlined'
            aria-label="add"
            style={{ width: 'fit-content', marginRight: '8px' }}
            onClick={() =>setExportModalOpen(true)}
            disabled={loading || exportLoading}
            startIcon={<Launch style={styles.icon} />}
          >
            {i18n.t('btnTableTileMatOverrides.export')}
          </Button>
        </div>
      </div>

      <div style={styles.buttonFilterContainer}>          
        <div style={styles.filterChipContainer}>
          {renderSiteChips()}
          {renderUsersChips()}
          {renderUsersMaintenancesChips()}
          {renderEquipmentModelsChips()}
          {renderEquipmentGroupsChips()}
          {renderServiceTypesChips()}
          {renderFrequenciesChips()}
          {renderPlacesChips()}
          {renderModulesChips()}
          {renderAreasChips()}
          {renderCompaniesChips()}
          {renderStatusChips()}
          {renderStatusMaintenancesChips()}
          {clearFilterButton()}
        </div>          
      </div>
      
      {loading && <Spinner overlay />}
      <CalendarStyled
        selectable
        popup
        localizer={localizer}
        events={calendarEvents}
        step={30}
        view={view}
        views={['month']}
        date={calendarDate}
        onView={view => setView(view)}
        culture={i18n.t('calendarStyledCompCalendar.culture')}
        onSelectEvent={e => onSelectEvent(e)}
        onNavigate={date => onNavigate(date)}
        messages={messages}
        components={{
          event: CustomEvent,
        }}
      />
      <EventModal />
    </Container>
  </>;
};

const styles = {
  buttonFilterContainer: {
    display: 'flex',
    flexDirection: 'column-reverse',
    justifyContent: 'space-between',
    padding: '0px 0px 10px 0px',
  },
  button: {
		marginLeft: '6em',
    minWidth: 200,
    maxHeight: 36,
	},
  buttonFilterIcon: {
    marginLeft: 5,
  },
  buttonFilter: {
    zIndex: 200,
    backgroundColor: 'green',
    marginRight: 5,
    height: '2.2rem',
    width: '6.5rem',
    padding: '1rem',
    color: '#fff',
  },
  clearFilter: {
    cursor: 'pointer',
    textDecoration: 'underline',
    zIndex: 200,
    padding: '0.75rem 0.5rem',
    color: '#000',
  },
  filterChipContainer: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  filterChip: {
    cursor: 'pointer',
    margin: '5px 10px 5px 0px',
  },
};

export default MyCalendar;
